export default "__VITE_ASSET__B0Uc8Xny__"